import { Injectable } from '@angular/core';
import { AbstractCacheService } from './AbstractCacheService';

@Injectable({
    providedIn: 'root'
})
export class SessionStorageService extends AbstractCacheService {
    constructor() {
        super(sessionStorage);
    }
}
